module.exports = __webpack_public_path__ + "img/primaPay.ae35bacc.png";